import { DataModel } from 'legacy/lut/classes/models/DataModel'
import { useMemo } from 'react'

import { Table } from 'core-components/library/list'
import MeasureController from 'core/analytics/MeasureController'
import { useMeasureController } from 'core/analytics/useMeasureController'

import { Cell } from './components/cell/Cell'
import { Row } from './components/row/Row'
import { IPartnerTableProps } from './models'

export const PartnerTable = ({
  className,
  crudSource,
  columns,
  disableExport,
  exportTooltip,
  cacheKeyWithColumn,
  openPartnerDialog,
  onEdit,
  flexWidth,
  onSelect,
  canSelectRule,
  disableEditMode,
  onboardingTable,
  disableEditAction,
  onDataLoad,
  metrics,
}: IPartnerTableProps) => {
  const { startLoadData, stopLoadData } = useMeasureController(metrics || 'WidgetPartnerTable')
  return (
    <Table<DataModel>
      className={className}
      header
      pagination
      measure={{ startLoadData, stopLoadData }}
      cacheKey={cacheKeyWithColumn}
      hasExport={!disableExport}
      exportTooltip={exportTooltip}
      source={crudSource}
      columns={columns}
      onDataLoad={onDataLoad}
      convertIFormToP={(data) => data.map((i) => new DataModel(i))}
      rowTpl={
        !disableEditMode
          ? (item, renderChildren, rowState, rowAttrs, additional) => {
              return (
                <Row
                  key={item.get('PartnerID')}
                  rowAttrs={rowAttrs}
                  item={item}
                  renderChildren={renderChildren}
                  rowState={rowState}
                  additional={additional}
                  colsNumber={columns.length}
                  openPartnerDialog={openPartnerDialog}
                />
              )
            }
          : undefined
      }
      cellTpl={(item, column, cellAttrs) => {
        return (
          <Cell
            key={`${item.get('PartnerID')}-${column.field}`}
            onSelect={onSelect}
            canSelectRule={canSelectRule}
            item={item}
            column={column}
            cellAttrs={cellAttrs}
          />
        )
      }}
      rowActions={
        onSelect && !onboardingTable
          ? [
              {
                id: 'edit',
                action: onEdit,
                title: 'Edit',
                icon: 'kbase kbase-edit kbase-sm',
              },
              {
                id: 'select',
                action: onSelect,
                title: 'Select',
                icon: 'kbase kbase-add',
              },
            ]
          : !disableEditAction
            ? [
                {
                  id: 'edit',
                  action: onEdit,
                  title: 'Edit',
                  icon: 'kbase kbase-edit kbase-sm',
                },
              ]
            : []
      }
      flexWidth={flexWidth}
    />
  )
}
